import type { ICourseDto } from "@ryde/shared";

import { formatCourseStationsCsvValue } from "./course-csv.utils";
import type { CsvCellTransformerFn, ICsvColumnTransformer } from "./models";

export const useCsvCourseStationsCellTransformer = (): {
  getCourseStationsValue: CsvCellTransformerFn;
} => {
  // The column holds bare station ids; the names live on the row's station info.
  const getCourseStationsValue = ({
    rowOriginal,
  }: ICsvColumnTransformer): string =>
    formatCourseStationsCsvValue(
      (rowOriginal as ICourseDto | undefined)?.metadata?.stationsInfo,
    );

  return { getCourseStationsValue };
};
